import { useContext } from "react";

import { trustpilotContext, TrustpilotContext } from "../contexts/trustpilot";

export function useTrustpilot(): TrustpilotContext {
  return useContext(trustpilotContext);
}
